import { render, staticRenderFns } from "./ProfessionMaster.vue?vue&type=template&id=536f3b4b"
import script from "./ProfessionMaster.vue?vue&type=script&lang=js"
export * from "./ProfessionMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports